import {
  LoadingProgress,
  NotFoundRoute,
} from '@issuemanager/apps/client/components';
import { useUserContext } from '@issuemanager/apps/client/contexts';
import { useFeatureFlags } from '@issuemanager/client/features/users';
import { FeatureFlagKey } from '@issuemanager/constants';
import React from 'react';
import { Outlet } from 'react-router-dom';

type FeatureFlagRouteProps = {
  featureFlag: FeatureFlagKey;
};

export function FeatureFlagRoute({
  featureFlag,
}: FeatureFlagRouteProps): React.JSX.Element {
  const { data: userData } = useUserContext();
  const isEnabled = useFeatureFlags(featureFlag);

  if (userData === undefined) {
    return <LoadingProgress height={500} />;
  }

  if (!isEnabled) {
    return <NotFoundRoute />;
  }

  return <Outlet />;
}
